import axios from 'axios'
import { delete_candidates } from '../settingSlice'

async function create_test(token,add_test,add_tests,tests,dispatch,setOpen,setMessage,data,setLoading,navigate,addData){

    setLoading(true)

      const addTest = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}add-test/`,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

      if (addTest?.status == 200 && addTest?.data?.success == true) {

      const newTests = [...tests,addTest?.data.test]

      await dispatch(add_tests(newTests))
      await dispatch(add_test(addTest?.data.test))
      await dispatch(delete_candidates())
      
      localStorage.setItem("iTest_test",JSON.stringify({
        id:addTest?.data.test?.id,
        name:addTest?.data.test?.name,
        description:addTest?.data.test?.description,
        time:addTest?.data.test?.time,
        start_moment:addTest?.data.test?.start_moment,
        start_date:addTest?.data.test?.start_date,
        questions:addTest?.data.test?.questions,
        language:addTest?.data.test?.language,
        describe:addTest?.data.test?.describe,
        specialty:addTest?.data.test?.specialty,
        field:addTest?.data.test?.field,
        level:addTest?.data.test?.level
      }))
      setMessage("Assessment created")
      setOpen(true)
      setLoading(false)
      addData({
        title:"Assessment Created",
        specialty:addTest?.data.test?.specialty,
        field:addTest?.data.test?.field,
        isCreated:true,
        level:addTest?.data.test?.level,
        language:addTest?.data.test?.language,
        questions:addTest?.data.test?.questions,
        id:addTest?.data.test?.id,
        from:addTest?.data.test?.name,
        start_moment:addTest.data.test?.start_moment,
        start_date:addTest.data.test?.start_date,
        time:addTest.data.test?.time,
        description:addTest?.data.test?.description
      })
      navigate("/testInfo")

      }else{
        setMessage(addTest?.data?.message)
        setOpen(true)
        setLoading(false)
      }

}

export default create_test